module.exports = "/_next/static/images/CallToAction-1af458277cbded5d595918eff4178807.svg";